import { ResolveFn } from '@angular/router';
import { MemberStore } from '../../store/member/member.store';
import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

export const getAllMembersResolver: ResolveFn<any> = (route, state) => {
  const memberStore = inject(MemberStore)

  memberStore.getAllMembers()

  return toObservable(
    computed(() => ({
      status: memberStore.memberLoadingStatus(),
      found: memberStore.entities().length > 0
    }))
  ).pipe(
    filter(({status}) => status === 'success' || status === 'error'),
    take(1),
    map(({ found }) => found)
  )
};
